// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownCircleTwoToneSvg from "@fishx/icons-svg/es/asn/DownCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var DownCircleTwoTone = function DownCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownCircleTwoToneSvg
  }));
};

DownCircleTwoTone.displayName = 'DownCircleTwoTone';
export default React.forwardRef(DownCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DownCircleTwoTone.js
// module id = 2460
// module chunks = 0